import type React from "react"

import { Box } from "@mui/material"
import type { SxProps, Theme } from "@mui/material"

import { getBlurSx } from "../get-blur-sx"
import type { BlurProps } from "./blur.types"

export const Blur: React.FC<BlurProps> = ({
  blurRadius = 4,
  children,
  component = "div",
  isBlurred = true,
  sx,
}) => {
  const blurStyles = getBlurSx({ blurRadius, isBlurred })

  return (
    <Box component={component} sx={[sx, blurStyles] as SxProps<Theme>}>
      {children}
    </Box>
  )
}
